import React from 'react';
import Navbar from "../components/Navbar";
import Portfolio from "../components/Portfolio";
import Footer from "../components/Footer";
import Hero from "../components/Hero";

export default class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <div className="home">
                <Navbar />
                <Hero />
                <Portfolio />
                <Footer />
            </div>
        )
    }

}
